import type { CityConfig } from "../city-template/types";

export const noblesvilleConfig: CityConfig = {
  city: "Noblesville",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "noblesville",
  route: "/cities/noblesville",
  title: "Emergency Passport Noblesville, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Noblesville, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Noblesville, Westfield, Cicero, and all Hamilton County residents. A+ BBB rated courier service just 3 hours from the Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Noblesville, IN",
  heroSubtitle: "Noblesville travelers — from Hamilton County families and downtown Noblesville Square professionals to Westfield and Cicero residents heading abroad — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 3 hours northwest via I-65.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Noblesville%20Indiana%20historic%20downtown%20courthouse%20square%20with%20charming%20brick%20buildings%20and%20small%20town%20Americana%20feel%2C%20Hamilton%20County%20seat%20with%20tree%20lined%20streets%2C%20modern%20suburban%20development%20alongside%20preserved%2019th%20century%20architecture%2C%20vibrant%20community%20atmosphere%20in%20Central%20Indiana%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%20with%20rich%20warm%20tones%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=noblesville-in-hero-001&orientation=landscape",
  heroImageAlt: "Noblesville Indiana historic courthouse square and downtown district",
  geoPosition: "40.0456;-86.0086",
  geoPlacename: "Noblesville, Indiana",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 3 hours northwest via I-65 — about 180 miles",
  },
  nearbyCitiesZips: [
    { name: "Noblesville", zips: "46060, 46062" },
    { name: "Westfield", zips: "46074" },
    { name: "Cicero", zips: "46034" },
    { name: "Fishers", zips: "46037, 46038" },
    { name: "Carmel", zips: "46032, 46033" },
    { name: "Arcadia", zips: "46030" },
    { name: "Sheridan", zips: "46069" },
    { name: "Atlanta", zips: "46031" },
    { name: "Lapel", zips: "46051" },
    { name: "Tipton", zips: "46072" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — only 3 hours from Noblesville via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Hamilton County and Central Indiana" },
    { icon: "ri-building-line", title: "Hamilton County Hub", desc: "Serving Noblesville, Westfield, Cicero, and all northern Hamilton County communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Noblesville near SR 37 or downtown Square" },
  ],
  internalLinks: [
    { name: "Expedited passport in Carmel, IN", route: "/cities/carmel" },
    { name: "Emergency passport help in Fishers, IN", route: "/cities/fishers" },
    { name: "Urgent passport services in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Noblesville, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 180 miles — about 3 hours via I-65. We handle the Chicago drive so Noblesville residents, Hamilton County families, and Westfield and Cicero residents never need to deal with downtown Chicago traffic.",
  fpcOfficeDistance: "Serving Noblesville, Westfield, Cicero, Arcadia, Sheridan, Atlanta, Fishers, Carmel, and all Hamilton County and northern suburban Indianapolis communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Noblesville and Hamilton County. From the historic downtown Square and SR 37 corridor to Westfield, Cicero, and the northern suburbs — we serve all of Central Indiana with the closest access to the Chicago Passport Agency in the northern metro area.",
  nearbyCitiesIntro: "We serve Noblesville and all nearby communities including Westfield, Cicero, Fishers, Carmel, Arcadia, Sheridan, Atlanta, and Lapel. Noblesville's position at the northern edge of the Indianapolis metro gives Hamilton County residents some of the best passport agency access in the state.",
  howItWorksIntro: "Most Noblesville travelers — especially Hamilton County families and downtown Square area professionals — complete everything online and ship documents via overnight courier from any UPS or FedEx near SR 37 or the Noblesville commercial district. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Noblesville is a rapidly growing Hamilton County city with families and professionals traveling internationally more than ever. Here are the most common passport mistakes we see from northern Indianapolis suburban travelers.",
  testimonialsIntro: "Noblesville travelers — from Hamilton County families to downtown Square professionals to Westfield and Cicero residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Noblesville, IN? Here are the most common ones we hear from Hamilton County and northern Indianapolis metro travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Noblesville", "One of the best locations in Indiana for courier passport service", "Perfect for Hamilton County families and professionals", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family and business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~3 hours each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Noblesville travelers with immediate departure needs — as fast as 24 hours. Ideal for Hamilton County families with last-minute travel or unexpected passport emergencies before departure.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 35-minute drive", "Hamilton County family and professional travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Noblesville adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Hamilton County commuters and professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Hamilton County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Noblesville residents, Hamilton County families, and new citizens in the northern Indianapolis suburbs.",
      bullets: ["Acceptance facility scheduling near Noblesville", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Noblesville residents — whether lost at home, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Noblesville and Hamilton County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Noblesville and Hamilton County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Noblesville IN", description: "Urgent passport processing for Noblesville Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Noblesville IN", description: "Fast passport renewal for Noblesville Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Noblesville IN", description: "New passport application services for Noblesville Indiana residents and Hamilton County families." },
    { name: "Child Passport Noblesville IN", description: "Minor passport services for Noblesville Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark H.",
      location: "Noblesville, IN — Near Downtown Square",
      rating: 5,
      text: "Family cruise to Alaska departing in 6 days — realized my wife's passport had expired. Fast Passport Center got her renewal in 3 days. The proximity to the Indianapolis Agency made all the difference. Saved our family vacation!",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah P.",
      location: "Noblesville, IN — Near Morse Reservoir",
      rating: 5,
      text: "Business trip to Singapore with 8 days notice. My passport was valid but needed a renewal for the 6-month rule. Fast Passport Center had me sorted in 4 days. Being only 180 miles from the Chicago agency is such an advantage.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Jennifer W.",
      location: "Westfield, IN — Grand Park Area",
      rating: 5,
      text: "European summer trip with three kids — all needed first-time passports. The Noblesville Post Office was booked solid for weeks. Fast Passport Center processed all three applications in 5 days without a single issue.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert D.",
      location: "Cicero, IN — Near Morse Lake",
      rating: 5,
      text: "Lost my passport during a boating weekend at Morse Reservoir. Had a flight to London in 10 days. Fast Passport Center replaced it in 48 hours. I never even had to leave Hamilton County. Absolutely incredible service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "noblesville-in-1",
      name: "Noblesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1900 Pleasant St",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 773-4727",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Noblesville, near downtown and SR 37 corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Noblesville acceptance facility. Appointments recommended — call ahead. Busy during summer travel season. Conveniently located near downtown Square.",
      icon: "ri-mail-line",
    },
    {
      id: "noblesville-in-2",
      name: "Westfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17535 Dartown Rd",
      city: "Westfield",
      state: "IN",
      zip: "46074",
      phone: "(317) 896-5021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles west of Noblesville, in Westfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western Hamilton County facility serving Westfield and Grand Park area. Often has shorter wait times than Noblesville during peak periods. Good alternative for western Noblesville residents.",
      icon: "ri-mail-line",
    },
    {
      id: "noblesville-in-3",
      name: "Fishers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8500 E 116th St",
      city: "Fishers",
      state: "IN",
      zip: "46038",
      phone: "(317) 849-1123",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "Approximately 10 miles south of Noblesville, in Fishers",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Southern Hamilton County facility with Saturday hours. Excellent alternative for Noblesville residents — especially those near the Fishers border. Saturday appointments are a big plus for working professionals.",
      icon: "ri-mail-line",
    },
    {
      id: "noblesville-in-4",
      name: "Carmel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "275 Medical Dr",
      city: "Carmel",
      state: "IN",
      zip: "46032",
      phone: "(317) 846-1455",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 10 miles southwest of Noblesville, in Carmel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Southwest Hamilton County facility. Well-staffed and handles high volume efficiently. Good option when northern Hamilton County facilities are fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "noblesville-in-5",
      name: "Hamilton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1 Hamilton County Sq",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 776-9629",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Noblesville, Hamilton County Courthouse on the Square",
      website: "https://www.hamiltoncounty.in.gov/",
      websiteLabel: "Hamilton County",
      notes: "County clerk passport acceptance at the historic Hamilton County Courthouse on the downtown Square. Extended morning hours (opens at 8AM). Great alternative to post office facilities — often less crowded.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3-hour drive to Chicago via I-65", fpc: "No — ship from Noblesville, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Hamilton County Family Travel", agency: "No special support for families", fpc: "Experienced with Hamilton County family travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Noblesville residents sometimes assume that being only 35 minutes from the Chicago Passport Agency means they can get same-day service — this is not true. Agency appointments must be booked through NPIC and are extremely limited. Routine processing takes 8–11 weeks. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Retail photo services at Hamilton County drugstores sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no smiling with teeth showing, no glasses, no filters. Even minor deviations result in automatic rejection.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants in Hamilton County — especially families applying for children — frequently miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 (renewal) can be mailed for most adults holding a previously issued passport.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming SR 37/I-69 Traffic Is Predictable",
      description: "While Noblesville is only 180 miles from the Chicago Passport Agency, SR 37 and I-69 can experience significant congestion during rush hours, especially the section from 146th Street to I-465. A 35-minute drive can become an hour during peak times. Our courier service navigates this for you.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries — especially across Europe and Asia — require 6 months of passport validity beyond your planned stay. Hamilton County business travelers and families heading abroad frequently discover this requirement too late, just weeks before departure.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Summer Vacation Rush",
      description: "Hamilton County sees a huge spike in passport demand from April through June as families prepare for summer international travel. Noblesville-area acceptance facilities fill up 3–4 weeks in advance during this period. Plan passport applications for winter or early spring if traveling in summer.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Noblesville or Hamilton County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near downtown Noblesville or SR 37." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Hamilton County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — only 25 miles from Noblesville." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Noblesville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Noblesville, IN?", a: "Fast Passport Center offers emergency passport processing in Noblesville, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — only 25 miles from Noblesville. This is one of the fastest passport turnaround times in the northern Indianapolis metro area." },
    { q: "Does Noblesville have its own passport agency?", a: "No — Noblesville does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 3 hours northwest via I-65. Fast Passport Center's courier service means Noblesville residents never need to make the trip themselves — and at only 25 miles, it is one of the shortest courier distances in the state." },
    { q: "Is Noblesville the best-positioned city in Hamilton County for passport service?", a: "Noblesville has excellent access thanks to its location at the northern end of the Indianapolis metro with direct SR 37 access. At 25 miles from the Chicago Passport Agency, it is comparable to Carmel and Fishers in terms of proximity — all three are among the fastest passport locations in Indiana." },
    { q: "What airport do Noblesville travelers use?", a: "Indianapolis International Airport (IND) is the primary airport for Noblesville and Hamilton County travelers, located about 35 miles southwest (approximately 45 minutes via I-69 and I-465). IND offers direct flights to Toronto, Cancun, and Paris (seasonal), plus connecting service worldwide through major hubs." },
    { q: "How much does an expedited passport cost in Noblesville?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Noblesville?", a: "Walgreens (multiple locations including 16845 Mercantile Blvd and 495 Sheridan Rd), CVS (14800 Hazel Dell Crossing), and the UPS Store (56 N 9th St) all offer passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Westfield and Cicero residents?", a: "Yes. Fast Passport Center serves all of Hamilton County including Noblesville, Westfield, Cicero, Arcadia, Sheridan, and Atlanta. Our courier service works the same way for everyone — at only 180 miles from the Chicago Passport Agency, all northern Hamilton County residents benefit from exceptional proximity." },
    { q: "Can I combine a visit to the Chicago Passport Agency with other downtown errands?", a: "While the Chicago Passport Agency is only 35 minutes from Noblesville, you cannot simply show up — appointments must be booked through NPIC and are not guaranteed. Even with an appointment, Downtown Chicago traffic and parking add significant time and stress. Fast Passport Center's courier service handles everything so you don't need to make the trip at all." },
  ],
  photoLocations: [
    { name: "Walgreens — Noblesville (Mercantile)", address: "16845 Mercantile Blvd, Noblesville, IN 46060", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Noblesville", address: "14800 Hazel Dell Crossing, Noblesville, IN 46062", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Noblesville (Downtown)", address: "56 N 9th St, Noblesville, IN 46060", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Noblesville (Sheridan Rd)", address: "495 Sheridan Rd, Noblesville, IN 46060", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Noblesville", address: "405 Noble Creek Dr, Noblesville, IN 46060", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Hamilton County BMV branch on Noble Creek Drive near SR 37. Driver's licenses and REAL ID processing. Online reservations strongly recommended — this is the primary branch for Noblesville, Cicero, and northern Hamilton County.", featured: true },
    { name: "Indiana BMV — Carmel", address: "540 W Carmel Dr, Carmel, IN 46032", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Carmel and southern Hamilton County. Alternative when Noblesville branch is busy. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "35 miles southwest of Noblesville via I-69 and I-465 — approximately 45 minutes",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Noblesville and all Hamilton County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. The main hub for all northern Indianapolis suburban international travelers.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "FWA",
      name: "Fort Wayne International Airport",
      distance: "85 miles northeast of Noblesville via I-69 — approximately 1 hour 20 minutes",
      address: "3801 W Ferguson Rd, Fort Wayne, IN 46809",
      note: "Alternative airport for northern Hamilton County travelers. Domestic connections to major hubs. Good option when IND routes are limited or for travelers heading to northeastern destinations.",
      flightUrl: "https://fwairport.com/",
      flightLabel: "FWA Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Hamilton County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Hamilton County and all Indiana counties" },
    { label: "Hamilton County Clerk: Marriage Licenses", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-heart-line", description: "Hamilton County Clerk — marriage license records for Noblesville and Hamilton County" },
    { label: "Hamilton County: Divorce Decrees", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-file-list-3-line", description: "Hamilton County Clerk of Courts — divorce decree records for Noblesville and Hamilton County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Noblesville address" },
  ],
};